<ng-container>
  <span class="layer-color-block"
        aria-hidden="true"
        *ngIf="layer.color"
        [ngStyle]="{backgroundColor: layer.color}">
  </span>
  <span class="layer-icon"
        aria-hidden="true"
        *ngIf="layer.iconClass"
        [ngClass]="layer.iconClass">
  </span>
  <span class="text-overflow layer-text">{{layer.label}}</span>
  <button class="btn-close" (click)="closeLayer.emit(layer)">
    <span class="sr-only">Close layer</span>
  </button>
</ng-container>


